const breakpoint = {
    XS: 'xs',
    S: 's',
    M: 'm',
    L: 'l',
};

const DEFAULT = breakpoint.M;

const detectBreakpointValue = function(style) {
    if (!style) {
        return DEFAULT;
    }

    const value = style.getPropertyValue('font-family').replace(/['"]/g, '');

    if (!value) {
        return DEFAULT;
    }

    for (const size in breakpoint) {
        if (value === breakpoint[size]) {
            return breakpoint[size];
        }
    }

    return DEFAULT;
};

const createMediaMarker = function() {
    const element = document.createElement('div');
    element.className = 'bloko-media-marker';
    document.body.appendChild(element);
    return element;
};

const getCurrentBreakpoint = function(mediaMarker) {
    if (!('getComputedStyle' in window)) {
        return DEFAULT;
    }

    const style = window.getComputedStyle(mediaMarker);

    return detectBreakpointValue(style);
};

let currentBreakpoint;

const lazyGetBreakpoint = () => {
    if (typeof currentBreakpoint === 'undefined') {
        const mediaMarker = createMediaMarker();
        currentBreakpoint = getCurrentBreakpoint(mediaMarker);

        window.addEventListener('resize', () => {
            currentBreakpoint = getCurrentBreakpoint(mediaMarker);
        });
    }
    return currentBreakpoint;
};

/**
 * Компонент для получения текущего значения media-выражения
 */
export default {
    /**
     * Enum с значениями media-выражений
     * @enum {string}
     */
    breakpoint,
    /**
     * Получаем текущее значение media-выражения
     * @returns {breakpoint}
     */
    getBreakpoint() {
        return lazyGetBreakpoint();
    },
};
